const KEY = "wird-locale";

export const LOCALE_ZH = "zh-CN";
export const LOCALE_EN = "en-US";

export function readStoredLocale() {
  try {
    const v = localStorage.getItem(KEY);
    if (v === LOCALE_EN || v === LOCALE_ZH) {
      return v;
    }
  } catch (e) {
    /* ignore */
  }
  return LOCALE_ZH;
}

export function persistLocale(locale) {
  try {
    localStorage.setItem(KEY, locale);
  } catch (e) {
    /* ignore */
  }
}

function pick(dict, path) {
  const parts = String(path || "").split(".");
  let cur = dict;
  for (let i = 0; i < parts.length; i++) {
    if (!cur || typeof cur !== "object") {
      return "";
    }
    cur = cur[parts[i]];
  }
  return typeof cur === "string" ? cur : "";
}

export function translate(dict, path, fallback) {
  return pick(dict, path) || fallback || path;
}
